<style lang="sass">
.main.close
    .order-dtl-map
        .footer
            width: calc(100% - 90px)!important
.dtl-status
    border: 1px solid #e9e9e9
    padding: 15px 20px
    overflow: hidden
    .statu-str
        font-size: 18px
        font-weight: 550
        span
            color: #FF3973
            margin-left: 10px
    .status-no,
    .status-tip
        color: #999
        margin-top: 10px
        span
            color: #282729
            margin-left: 5px
    .el-btn
        margin-top: 10px


.dtl-title
    background: #F5F5F5
    font-weight: 500
    height: 40px
    line-height: 40px
    padding: 0 20px
    margin-top: 20px
    img
        float: left
        width: 16px
        margin-right: 10px
        margin-top: 12px
.dtl-main
    border: 1px solid #e9e9e9
    border-top: none
    padding: 20px

.fix-center.cancel-box
    .fix-center-main
        padding: 20px 20px 0!important

.reasons
    text-align: center
    .el-radio-group
        width: 280px
        margin: 20px auto 0
        text-align: left
        overflow: hidden
        .el-radio
            width: 50%
            margin-bottom: 10px
            color: #999
            &+.el-radio
                margin-left: 0
            .el-radio__input.is-checked
                .el-radio__inner
                    background: #fff
                    border-color: #282729
                    transition: none
                    &::after
                        background: #282729
                        width: 6px
                        height: 6px
                        transition: none
                &+.el-radio__label
                    color: #282729

    .radio-group
        margin: 20px auto 0

    .text
        width: 280px
        margin: 10px auto

    .tip
        font-size: 16px
        line-height: 80px
        border-top: 1px solid #e9e9e9
        margin-top: 15px

.judge_box
    text-align: center
    .star-str
        font-size: 16px
        margin-bottom: 10px
    img
        width: 25px
        margin: 10px
        cursor: pointer
    .text-area
        margin: 20px auto 0
        width: 280px
    .el-textarea
        width: 100%
        textarea
            height: 130px
            font-size: 12px
            resize: none
.dtl-status
    .el-btn
        margin-left: 20px
        &.mt25
            margin-top: 25px

.detail_screen
    margin: 10px auto
    display: inline-block

.usepf_span.detail
    width: 100%
    padding-right: 0!important
    > span
        display: inline-block
        width: calc(100% - 70px)
        position: relative
        top: 2px

.el-popover.el-popper.dtl_pop
    padding: 15px 20px
</style>

<style lang="sass" scoped>
.nbhd_s
  ::v-deep .el-input__suffix
    > span
      position: relative
      top: -6px

.detail_de
    width: 200px
    height: 40px
    color: #666666
    background: #F5F5F5
    border-radius: 2px
    padding: 10px
    float: left
    margin: 5px
    cursor: default
    &.active
        border: 1px solid #6296FF
        background: #fff
    i
        margin-left: 10px
    span
        color: #282729
        font-weight: 500
        font-size: 14px

.gg-tabs
    border-bottom: 1px solid #e9e9e9
    margin-bottom: 10px
.footer
    height: 60px
    position: fixed
    right: 20px
    bottom: 0
    border-top: 1px solid #E9E9E9
    margin-left: -40px
    padding: 10px 20px
    width: calc(100% - 300px)
    background: #fff
    .fr
        .sunCount
            cursor: pointer
            .s_title
                font-size: 14px
                font-weight: 400
                color: #282729
                margin-top: 10px
            .numDe
                margin-right: 20px
                .numUp
                    font-size: 18px
                    font-weight: 600
                    color: #FF3973
                    line-height: 24px
                    margin-top: 8px
                .numDown
                    text-decoration: line-through
                    font-size: 12px
                    margin-left: 2px

.countDetail
    width: 200px
    color: #282729
    .countLine
        margin: 10px 5px
        span
            font-size: 14px
        span:last-child
            color: #FF3973

.final
    font-weight: 600
    padding: 10px 0
    line-height: 30px
    text-align: right
    margin-top: 20px
    background: #f5f5f5
    div
        font-weight: 400
        color: #999
        span
            color: #999
            margin-left: 10px
            &.price
                color: #282729
            &.cp
                color: #FF3973

.order-dtl-map
    padding: 20px
    height: calc(100% - 60px)
    overflow: auto
    .cf-top
        margin-bottom: 20px
        .part-title
            margin-bottom: 30px
            .fr
                color: #FF3973
                width: 100px
                height: 30px
                line-height: 30px
                border: 1px solid #FF3973
                border-radius: 4px
                font-size: 14px
                text-align: center
                cursor: pointer

    .user-info, .type-info
        &.cpr_plus
          display: flex
          align-items: center
          // justify-content: space-between
          justify-content: flex-start
          overflow: hidden
        .each
          display: inline-block
          color: #999
          line-height: 1
          padding-right: 20px
          margin-right: 20px
          border-right: 1px solid #e9e9e9
          .btn
            color: #6296FF
            cursor: pointer
          .unit_append
            height: 28px
            line-height: 28px
            position: relative
            right: 50px

          &.noMr
            border-right: none
          &.customize_box
            // width: calc(100% - 128px)
            flex-basis: auto
            line-height: 16px
            border-right: none
            box-shadow: 1px 0px 0px 0px #e9e9e9
            font-weight: 500
            white-space: nowrap
            overflow: hidden
            text-overflow: ellipsis
          &.cpl_mode
            flex-basis: 104px
            flex-shrink: 0
            line-height: 26px
            margin-right: 0
            padding-right: 0
          span
            color: #282729
            margin-left: 5px

        .contract
            .btn
                color: #6296FF
                cursor: pointer
            .el-input
                display: inline-block
                width: 210px

    .pkg_list
        .each
            width: calc(100% - 60px)
            display: inline-block
            margin-right: 0
            padding-right: 0
            span
                width: calc(100% - 80px)
                display: inline-block
                vertical-align: top

        .fr
            padding-left: 10px
            line-height: 1
            border-left: 1px #e9e9e9 solid
            margin-top: 8px
            cursor: pointer

    .cf-info
        .less
            color: #999
            span
                color: #282729
                &.btn
                    color: #6296FF
                    cursor: pointer
        .line-box
            padding: 10px 20px
            line-height: 26px
            border: 1px solid #e9e9e9
            border-radius: 4px
            margin-bottom: 10px
        .put-time
            font-weight: 400
            > span
                display: inline-block
                color: #999
                span
                    color: #282729
                    font-weight: 500
                    padding-right: 20px
                    margin-right: 20px
                    border-right: 1px solid #e9e9e9
                    &.date
                        font-size: 16px
                        font-weight: 550

            .row_els
                margin-right: 0
                width: 100%
                display: inline-block
                vertical-align: top
                text-overflow: ellipsis
                overflow: hidden
                white-space: nowrap
                padding-right: 0
            .value_els
                max-width: 300px
                text-overflow: ellipsis
                overflow: hidden
                white-space: nowrap
                display: inline-block
                vertical-align: top
            .cpr_btn
              cursor: pointer
              color: #6296FF
              border: none
              margin-left: 5px
              padding-right: 0
              margin-right: 0

        .max300
            max-width: 300px
            display: inline-block

    .community-list
        text-align: center
        .community-item
            padding: 0 20px
            border-radius: 4px
            border: 1px solid #e9e9e9
            margin-bottom: 10px
            cursor: pointer
            &.isOpen
                .top
                  i
                    transform: rotate(180deg)
            .top
              line-height: 50px
              text-align: left
              .fr
                color: #999
                span
                  padding-right: 20px
                  margin-right: 20px
                  border-right: 1px solid #e9e9e9
                  margin-left: 5px
                  &.price
                    color: #FF3973
                  &.num
                    color: #282729
                  &.no-br
                    padding-right: 0
                    margin-right: 0
                    border-right: none
                i
                  margin-left: 20px

            .table
                line-height: 40px
                width: calc(50% - 10px)
                background: #F5F5F5
                float: left
                margin-top: 10px
                margin-bottom: -1px
                position: relative
                &:nth-of-type(2n)
                    float: right

                > div
                    border-bottom: 1px solid #e9e9e9

                .line-bottom
                    height: 2px
                    width: 100%
                    border-bottom: none
                    background: #F5F5F5
                    position: absolute
                    bottom: 0
                    left: 0

                .date
                    padding: 0 12px
                    .fr
                        color: #999
                        font-size: 12px
                        span
                            font-size: 14px
                            color: #FF3973
                            font-weight: 550
                .item
                    width: 50%
                    float: left
                    color: #999
                    text-align: center
                    font-size: 12px
                    position: relative
                    .item-line
                        position: absolute
                        right: 0
                        top: 10px
                        width: 1px
                        height: 20px
                        background: #E9E9E9

                    span
                        color: #282729
                        &.num
                            color: #FF3973
                            margin-left: 5px
.span-high-line-space
    line-height: 1.5
.unit_append
  position: relative
  ::v-deep .el-input
    input
      text-align: left
  .numberText
    position: absolute
    height: 28px
    line-height: 28px
    right: 60px
</style>

<template lang="pug">
main-right(title="我的订单")
  .order-dtl-map
    .cf-top
      .part-title 订单详情
        .fr(@click="goBack" v-if="isShowBack")
          i.el-icon-arrow-left
          span 返回

      .dtl-status
        .fl
          .statu-str 当前状态：
            span {{itemData.orderStatusName}}
            span(v-if="itemData.orderStatus == 4 && itemData.validStartDate && itemData.validEndDate") ({{ `${ itemData.validStartDate }-${ itemData.validEndDate }` }})
          .status-no 订单编号：
            span {{itemData.orderCode}}
          .status-tip(v-if="itemData.orderStatus==0") 剩余时间：
            span {{leftTime}}
          .status-tip(v-if="itemData.orderStatus==4") 订单已完成，感谢您在梯之星购买投放服务，欢迎您对本次服务进行评价。
        .fr
          .el-btn.red.mt25(v-if="itemData.orderStatus==0" @click="goUrl('/orderPay', { id: itemData.guid, freeMark: itemData.payWay })") 立即支付
          .el-btn.mt25(v-if="itemData.orderStatus==0" @click="cancelOrder(itemData)") 取消订单
          template(v-if="itemData.orderStatus==2 || itemData.orderStatus==3")
            .el-btn.red(@click="setCurrentDetail(itemData, 'showUpload')") {{opTypeStr}}{{typeStr}}
          .el-btn.red.mt25(v-if="itemData.orderStatus==4 && !itemData.appralId" @click="giveMark(itemData)") 我要评价
          .el-btn.disabled(v-if="itemData.orderStatus==4 && itemData.appralId") 已评价

      .dtl-title 客户信息
        img(src="../../assets/title-icon.png")
      .dtl-main
        .user-info
          span.each 联系人：
            span {{customer.contacter}}
          span.each 联系人电话：
            span {{customer.contactPhone}}
          span.each.noMr 认证主体：
            span {{adUser.customerName}}

      .dtl-title 支付信息
        img(src="../../assets/title-icon.png")
      .dtl-main
        .user-info
          span.each 支付方式：
            span {{itemData.payWayName}}
          span.each 下单时间：
            span(v-if="itemData.createTime") {{new Date(itemData.createTime) | timeNoS}}
          span.each 上链服务：
            span {{ itemData.chainFlagName || '--' }}
          span.each.noMr 数据存储
            el-tooltip(effect="dark" placement="top-start")
              i.el-icon-question(style="margin-left: 5px;")
              div(slot="content")
                div 播放数据存储的有效期,包
                div 括数据报告&流量抓图
            span ：  &nbsp; {{itemData.pictureStorageDays}} 天
    .dtl-title 订单信息
      img(src="../../assets/title-icon.png")
    .dtl-main(style="padding: 10px 10px 0;")
      .cf-info
        .put-time.line-box
          span 广告名称：
            span.no-br {{ itemData.contentName || '虚位以待' }}

        //- .put-time.line-box(v-if="!isWifi && !isH5RealTime && itemData.subtitle")
        //-   span 广告字幕：
        //-     span.no-br {{ itemData.subtitle }}

        .put-time.line-box
          template(v-if="isCpmL")
            span 起始日期：
              span.date.no-br {{ itemData.startDate | date1 }}
                | (预计{{itemData.dateNum }}天)
                el-tooltip(effect="dark" placement="top-start")
                  i.el-icon-question(style="margin-left: 5px;")
                  div(slot="content")
                    div 以实际投放天数为准。如当前天数
                    div 已满足流量，则提前结束订单。
          template(v-else-if="isPkg")
            span 投放日期：
              span.date.no-br {{itemData.startDate | date1}} ~ {{itemData.endDate | date1}}(共{{ itemData.showAdd2 ? `${itemData.dateNum - 2}+2` : itemData.dateNum }}天)
                el-tooltip(effect="dark" placement="top-start" v-if="itemData.showAdd2")
                  i.el-icon-question(style="margin-left: 5px;")
                  div(slot="content")
                    div {{ itemData.dateNum - 2 }}天为实际选择天数，2天为系统预留天数，
                    div 如实际选择天数流量满足，则系统预留天数收回。
          template(v-else)
            span 投放日期：
              span.date.no-br(v-if="itemData.startDate")
                | {{itemData.startDate | date1}} ~ {{itemData.endDate | date1}}(共{{ itemData.dateNum }}天)
              span.no-br(v-else) 无
          span(style="float:right" v-if="orderGroupObjList[0]") 订单组别：
            span.date.no-br(style="margin-right:0") {{orderGroupObjList[0].startDate}} ~ {{orderGroupObjList[0].endDate }}
            el-tag(v-if='orderGroupObjList[0].tag' size='mini' style='color:#409EFF;background-color:#ecf5ff;border-color:#d9ecff;padding-right:5px') {{ orderGroupObjList[0].tag }}
            el-button(type='text' size='small' style="color:#FF3973" @click="editOrderGroupEvent") 编辑
        .put-time.line-box(v-if="!isWifi && !isH5RealTime && !screenAreaIs1(itemData)")
          span.row_els 投放时段：
            StrPop
              span.no-br(v-if="itemData.timeSlotNames" v-html="itemData.timeSlotNames" slot="reference")
              div(v-html="itemData.timeSlotNames")

        .type-info.line-box
          StrPop
            span.each(slot="reference") 投放城市：
              span {{ itemData.addressCodesName || '不限' }}
            div {{ itemData.addressCodesName || '不限' }}
          span.each(v-if="!isWifi && !isH5RealTime") 单次曝光：
            span {{ itemData.contentTime ? itemData.contentTime + '秒' : '不限' }}
          span.each(
            v-if="!isH5RealTime && !isWifi && !isSmallSn"
            :class="{ 'no-br': !isCpm && itemData.contractNo === null }") 收费方式：
            span {{ labelData.costTypeName || '' }}

          span.each.unit_append(v-if="targetType===3") 每日流量上限：
            template(v-if="dayTrafficChange")
              el-input-number(size="mini" :min="0.01"
                :max="99999"
                :precision="2"
                :step="0.1" :controls="false"  style="width:150px;" v-model="daliFlowLimitNum")
              i.numberText 千人次
              span.btn(@click="changeDayTraffic(false,daliFlowLimitNum)") 确定
            template(v-else)
              span {{ itemData.daliFlowLimit || itemData.daliFlowLimit === 0? (itemData.daliFlowLimit / 1000).toFixed(2) + '千人次' : '不限' }}
              span.btn(
                v-if="itemData.orderType === 6005 || itemData.orderType === 6010"
                @click="changeDayTraffic(true,itemData.daliFlowLimit)"
              ) {{ '修改' }}
          span.each.no-br(v-if="isCpm") {{ labelData.targetName  }}:
            span {{ itemData.expectFlow ? (itemData.expectFlow / 1000).toFixed(2) + '千人次' : '不限' }}
          span.each.no-br(v-if="isPkg") 目标流量：
            span {{ itemData.expectFlow ? itemData.expectFlow + '人次' : '不限' }}

          span.each.no-br.contract(v-if="itemData.contractNo !== null") 合同编码：
            template(v-if="contarctChanging")
              el-input(size="mini" :maxlength="30" v-model="destContractNo")
              span.btn(@click="changeContractNo") 确定
            template(v-else)
              span.no-br {{ itemData.contractNo || '未录入' }}
              span.btn(
                v-if="!isPkg"
                @click="contarctChanging = true; destContractNo = itemData.contractNo;"
              ) {{ itemData.contractNo ? '修改' : '立即录入' }}

          span.each.no-br.noMr 展现位置：
            span(v-if="displayRegionName") {{ '主屏+副屏' }}
            span(v-else) 主屏+副屏

        .put-time.line-box
          span.each 合同单价：
            span {{ itemData.unitPrice || '--' }}
          template(v-if="isCprPlus")
            span 流量总限：
              span(v-if="itemData.expectFlow") {{ (itemData.expectFlow / 1000).toFixed(2) }} 千人次
              span(v-else) 不限
            span 流量日限：
              span {{ itemData.daliFlowLimit ? (itemData.daliFlowLimit / 1000).toFixed(2) + '千人次' : '不限' }}
                span.cpr_btn(@click="onModify('maxFlowNumPerDate')") 修改
            span 点位日限流量：
              span {{ itemData.pointLimitFlow? itemData.pointLimitFlow + '人次' : '不限' }}
                //- span.cpr_btn(@click="onModify('maxPointLimitFlow')") 修改
            span 点位日限频次：
              span.no-br {{ itemData.pointLimitPlayCount? itemData.pointLimitPlayCount + '次' : '不限' }}
                span.cpr_btn(@click="onModify('maxPointLimitPlayCount')") 修改

        .type-info.line-box(v-if="labelData.labelDataChangeType === 'indus'")
          span.each.no-br 我的行业：
            span {{ labelData.industryName || '不限' }}
        .type-info.line-box.cpr_plus(v-else-if="isCprPlus")
          span.each.customize_box(ref="cplLabel") CPR+标签：
            span(:title="labelTip") {{ fullLabelName }}
          span.each.no-br.cpl_mode 投放模式：
            span {{ cplModeStr }}
        template(v-else)
          .type-info.line-box
            span.each(v-for="(nbhdLabel, i) in labelData.nbhdNames" :key="nbhdLabel.groupName" :class="{ 'no-br': i == labelData.nbhdNames.length - 1 }") {{ nbhdLabel.groupName }}：
              span {{ nbhdLabel.labels && nbhdLabel.labels.length ? nbhdLabel.labels.join(',') : '不限' }}
          .type-info.line-box
            span.each.no-br.usepf_span.detail 用户画像：
              span(style="display: inline-block;width: calc(100% - 80px);position: relative;top: 0px;")
                //- 2023-11-09 订单详情用户画像开放【修改】入口,仅准备中订单可修改
                UserProfileChange(:onlyshow="itemData.orderStatus !== '2'" :codes="itemData.orderCode" v-model="labelData.personNamesData")

        .type-info.line-box(v-if="!isCprPlus")
          span.each.no-br 禁播标签：
            span.span-high-line-space {{ itemData.noPlayingLabels || '不限' }}

        template(v-if="packageInfo")
          .type-info.line-box
            span.each 套餐名称：
              span {{ packageInfo.packageInfoName }}
            span.each 目标流量：
              span {{ packageInfo.packageFlow }}人次
            span.each.no-br 套餐数量：
              span {{ packageInfo.packageInfoCodes.length }}

          .type-info.line-box.pkg_list
            span.each.no-br 套餐名称：
              span(:class="{ 'els': !isShowMorePkg }") {{ packageInfo.packageInfoCodes.join('、') }}
            .fr(@click="isShowMorePkg = !isShowMorePkg")
              span(v-if="isShowMorePkg") 收起
              span(v-else) 展开

        .line-box(style="font-weight: bold;") 共选{{itemData.deviceCount || 0}}个点位
          template(v-if="!isWifi") （梯内屏{{tnDeviceNum}}个，梯外屏{{twDeviceNum}}个）
          | ；覆盖{{itemData.nbhdCount || 0}}个小区
          //- cpm展示预计流量
          span(v-if="isCpm") ；预计流量{{ itemData.showFlowpredict || 0 }}（千人次）

    .dtl-title 小区信息
      img(src="../../assets/title-icon.png")
      .fr
        InputSearch.nbhd_s(
          @search="search" ref="nbhdSearch" style="background: #fff;line-height: 30px;margin-top: 5px;"
          placeholder="查找小区" :clearSearch="true")

    .dtl-main(style="padding: 10px 10px 0;margin-bottom: 10px;")
      .gg-tabs(v-if="!isWifi && !isH5RealTime")
        .gg-tab(
          v-for="(item, i) in ['梯内屏', '梯外屏']" :key="i" @click="toggleTypeTab(i)"
          :class="{'cur': curTab == i, 'disabled': !allCommunityList[i] || allCommunityList[i].length == 0}"
        ) {{ item }}
          span {{ allCommunityList[i] && allCommunityList[i].length > 0 ? '' : '(未投)' }}
      .community-list(ref="listCtn")
        .data-none(v-if="showCommunityList.length == 0") 暂无数据
        .community-item(v-for="(item, i) in showCommunityList" :class="{'isOpen':item.isOpen}")
          .top(@click="showNbhdDetail(item)") {{item.name}}
            .fr 合计金额:
              span.price {{(item.slotAmount ? item.slotAmount - 0 : 0).toFixed(2)}}元
              | 点位数:
              span.num(:class="isWifi ? 'no-br': ''") {{item.deviceCount}}个
              template(v-if="!isWifi")
                | 已投:
                span.num.no-br {{ item.validDays ? item.validDays : 0 }}天
              i.el-icon-arrow-down
          .community-main(v-if="item.isOpen" @click.stop="")
            .detail_screen(:style="{ width: listCtnWidth + 'px' }")
              template(v-for="(it, j) in item.nbhdDailyRes")
                .detail_de(v-if="isShowBuild") {{it}}
                date-device-item(v-else :data="it" :idx="i" @show="dateDeviceClick")
            .clear
    .footer(:style="{ width: fixedWidth ? fixedWidth + 'px' : '' }")
      .fr
        el-popover(placement="top" width="200" trigger="click")
          .countDetail
            .countLine
              span 广告总价：
              span(style="font-weight:600;color:#282729;") +￥{{itemData.amountOri ? (itemData.amountOri - 0).toFixed(2) : '0.00'}}
            .countLine
              span 满减折扣：
              span -￥{{itemData.amountSale ? (itemData.amountSale - 0).toFixed(2) : '0.00'}}
            .countLine
              span 活动金额：
              span -￥{{itemData.amountActivity ? (itemData.amountActivity - 0).toFixed(2) : '0.00'}}
            .countLine
              span 优惠券：
              span -￥{{itemData.amountCoupon ? (itemData.amountCoupon - 0).toFixed(2) : '0.00'}}
            .countLine(v-if="itemData.payWay == 1")
              span 会员权益：
              span 减免{{itemData.vipReduce || 0}}点位

          .sunCount.fl(slot="reference")
            .s_title.fl
              | 实付金额：
            .numDe.fl
              .numUp.fl ￥{{itemData.amount ? (itemData.amount - 0).toFixed(2) : '0.00'}}
              i.iconfont.icon-bangzhu(
                style="position: relative;top: 12px; left: 5px;color: #FF7413;"
              )

    UploadVideo(v-model="currentRow" @upDone="changeVideoDone")

    fix-center.cancel-box(ref="cancelFixCenter" w="400" :h="cancelBoxHeight")
      template(slot="title") 取消订单
      template(slot="main")
        .cancel-main 您取消订单的原因是：
          .reasons
            .radio-group(v-model="curReasonIdx")
              .radio(@click="curReasonIdx=i" v-for="(item, i) in reasons" :key="i" :label="i" :class="{ 'cur': curReasonIdx == i}" ) {{item}}
                .circle
                  .black
            .text(v-if="curReasonIdx==6")
              el-input(type="textarea" v-model="reasonStr")

            .tip 温馨提示：订单取消后将无法恢复
      template(slot="btm")
        .fix-btn.red(@click="cancel") 确认并取消订单
        .fix-btn(@click="cancelCancel") 取消

    fix-center(ref="markPop" w="400" h="385")
      template(slot="title") 我要评价
      .judge_box(slot="main")
        .star-str {{starStr}}
        template(v-for="(item, i) in starIdx+1")
          img(src="../../assets/star1.png" v-if="starIdx<2" @click="starIdx=i")
          img(src="../../assets/star2.png" v-if="starIdx==2" @click="starIdx=i")
          img(src="../../assets/star3.png" v-if="starIdx>2" @click="starIdx=i")
        template(v-for="(item, i) in 5-starIdx-1")
          img(src="../../assets/star0.png" @click="starIdx=starIdx+i+1")

        .text-area
          el-input(type="textarea" v-model="judgeStr" placeholder="请写下您的感受，对我们会有很大帮助哦~" maxlength="200")
          .text-num {{judgeStr.length}}
            span /200

      template(slot="btm")
        .fix-btn.red(@click="judge") 提交评价
        .fix-btn(@click="hideMarkPop") 取消

    CprDailPop(:cprDaily="popData" v-model="cprPop" @refresh="refreshOrder")
    editOrderGroup(ref="editOrderGroupRef" @confirmGroup="editOrderGroupCode")
</template>

<script>
import { addResizeListener, removeResizeListener } from 'element-ui/lib/utils/resize-event'
import UploadVideo from '@/components/UploadVideo'
import DateDeviceItem from './components/DateDeviceItem.vue'
import InputSearch from '@/components/InputSearch.vue'
import UserProfileChange from '@/components/userprofile/UserProfileChange'
import StrPop from '@/components/StrPop.vue'
import CprDailPop from './components/CprPlusDailyPop.vue'
import editOrderGroup from './editOrderGroup.vue'
import {jsUuid} from '@/utils/functions.js'

export default {
  name: 'OrderDetail',
  components: { UploadVideo, DateDeviceItem, InputSearch, UserProfileChange, StrPop, CprDailPop,editOrderGroup },
  filters: {
    date1(v) {
      let trimV = (v + '').trim()
      return trimV == '' ? '' : trimV.replace('-', '年').replace('-', '月') + '日'
    }
  },
  data() {
    return {
      orderGroupObjList: [],
      daliFlowLimitNum:0,
      dayTrafficChange:false, // 每日流量上限改变
      itemData: {
        timeSlotNames: ''
      },
      communityList: [],
      leftSeconds: 30 * 60 - 1,
      currentRow: {
        showUpload: false
      },
      curReasonIdx: -1,
      delItem: null,
      reasons: [
        '支付不成功',
        '忘记使用优惠券',
        '订单价格有问题',
        '广告位价格较高',
        '错误或重复购买',
        '现在不想购买',
        '其他'
      ],
      types: null,
      isShowDetail: false,
      curDtl: {},
      cancelBoxHeight: 385,
      reasonStr: '',
      judgeStr: '',
      starIdx: -1,

      listCtnWidth: 0,
      fixedWidth: 0,
      userPfList: [],

      curTab: 0,
      allCommunityList: [],
      showCommunityList: [],
      tnDeviceNum: 0,
      twDeviceNum: 0,
      isShowBack: false,
      labelData: { personNamesData: [] },

      isShowMorePkg: false,

      contarctChanging: false,
      destContractNo: '',
      packageInfo: null,

      targetLabels: [],
      labelTip: '',

      popData: {
        orderId: undefined,
        propKey: undefined,
        maxFlowNumPerDate: undefined,
        maxPointLimitFlow: undefined,
        maxPointLimitPlayCount: undefined
      },
      cprPop: false
    }
  },
  computed: {
    targetType() {
      return this.itemData.targetType
    },
    isCpd() {
      return this.itemData.orderType == 6001
    },
    isPkg() {
      return this.itemData.orderType == 6003
    },
    isCpm() {
      return this.itemData.orderType == 6002
    },
    isCpmL() { // cpm按流量
      return this.isCpm && this.itemData.stopTypes && this.itemData.stopTypes.indexOf(2) > -1
    },
    isCprPlus() {
      return this.itemData.orderType == 6005
    },
    isWifi() {
      return this.itemData.screenArea == 3
    },
    isSmallSn() {
      return this.itemData.screenArea == 1
    },
    isH5RealTime() {
      return this.itemData.screenArea == 4
    },
    isShowBuild() { // wifi   cpm按流量  cpm按天
      return this.isWifi || this.isCpm
    },
    userLabelStr() {
      const arr = this.labelData.personCodes
      if (!arr || arr.length === 0) return ''
      const code2name = this.$store.state.label.codeMap
      if (arr.length === 1) return arr[0].map((el) => code2name[el].name).join('+') // 一个时 多个属性时不显示括号
      return arr
        .map((list) => {
          let str = list.map((el) => code2name[el].name).join('+')
          return list.length == 1 ? str : `(${str})` // 一个属性时不展示括号
        })
        .join(' 或 ')
    },
    fullLabelName() {
      if (this.targetLabels.length > 0) {
        return this.targetLabels.map(tag => {
          const str = tag.map(({ name, countValue }) => {
            return countValue > 0 ? `${name}+${countValue}` : name
          }).join('+')
          return tag.length > 1 ? `(${str})` : str
        }).join(' / ')
      }
      return ''
    },
    cplModeStr() {
      const m = {
        1: '标准',
        2: '高级'
      }
      return m[this.itemData.dmpInterruptType] || '--'
    },
    opTypeStr() {
      return this.itemData.execStatus ? '更换' : '上传';
    },
    typeStr() {
      return this.isWifi ? 'URL' : '素材';
    },
    screenAreaIs1() {
      return item => {
        return !item || !item.hasOwnProperty('screenArea') || item.screenArea == 1
      }
    },
    adUser() { return this.$store.state.customer.userInfo },
    customer() { return this.$store.state.customer.customerInfo },
    leftTime() {
      let time = this.leftSeconds
      let h = Math.floor(time / 3600)
      let m = Math.floor(time % 3600 / 60)
      let s = time % 60
      return add0(h) + ':' + add0(m) + ':' + add0(s)
      function add0(t) {
        return t - 0 < 10 ? '0' + t : t
      }
    },
    starStr() {
      let arr = ['效果非常差，联系客服', '效果很差，我要吐槽', '效果一般，需要改善', '效果很好，再接再厉', '效果非常好，无可挑剔']
      if (this.starIdx > -1) return arr[this.starIdx]
      return '效果满意度'
    },
    allDeviceNum() {
      if (!this.itemData || !this.itemData.orderNbhdResList) return 0
      return this.itemData.orderNbhdResList.reduce((a, b) => a + b.deviceCount, 0)
    },
    fee() {
      return (money, type) => {
        if (!money) return type ? '00' : 0
        let isMinus = money < 0
        if (isMinus) money = 0 - money
        if (!type) {
          let arr = (Math.floor(money) + '').split('').reverse()
          let a = []
          arr.forEach((el, i) => {
            a.push(el)
            if ((i + 1) % 3 == 0) a.push(',')
          })
          let str = a.reverse().join('')
          let data = str.charAt(0) == ',' ? str.slice(1) : str
          return isMinus ? '-' + data : data
        } else {
          money = (money - 0).toFixed(2)
          let sp = (money + '').split('.')
          return sp.length > 1 ? ((sp[1] + '').length == 1 ? sp[1] + '0' : sp[1]) : '00'
        }
      }
    },
    chooseNum() {
      return this.communityList.reduce((a, b) => b.deviceCount + a, 0)
    },
    displayRegionName() {
      if(!this.itemData.displayRegion) {
        return "不限"
      }
      switch (this.itemData.displayRegion) {
        case 1:
          return "主屏";
        case 2:
          return "副屏";
        case 3:
          return "主屏+副屏"
      }
      return ""
    }
  },
  watch: {
    curTab(idx) {
      this.showCommunityList = this.allCommunityList[idx] || []
      this.$refs.nbhdSearch.search()
    }
  },
  beforeDestroy() {
    removeResizeListener(this.$refs.cplLabel, this.handleResize)
    window.removeEventListener('resize', this.handleListCtnWidth)
    document.body.removeEventListener('click', this.handlePopover, true)
    document.querySelector('.order-dtl-map') && document.querySelector('.order-dtl-map').removeEventListener('scroll', this.bdClick)
  },
  created() {
    this.getOrder()
    if (this.$route.query.noBack != 1) this.isShowBack = true
    if (!this.$store.state.label.list.length) this.$store.dispatch('label/getSearchLabels') // 标签Label
  },
  mounted() {
    if (this.$route.path == '/mapOrderDetail') {
      const t = setTimeout(() => {
        clearTimeout(t)
        this.handleListCtnWidth()
        document.querySelector('.order-dtl-map') && document.querySelector('.order-dtl-map').addEventListener('scroll', this.bdClick)
      }, 450)
      window.addEventListener('resize', this.handleListCtnWidth)
    }
  },
  methods: {
    // 修改订单组别
    async editOrderGroupCode(code){
      const params = {
            orderId: this.itemData.guid,
            orderCode: this.itemData.orderCode,
            orderGroupCode:code
        }
        console.log(this.daliFlowLimitNum)
        let res = await this.fetch(`/orderlite/order/api/v4/order`, { ...params }, 'put')
        if (res && res.code === 0) {
          this.messageTip(res.msg || '操作成功', 1)
          this.refreshOrder()
        }
    },
    async editOrderGroupEvent(){
      const groupList = await this.getOrderGroupLisrt()
      this.$refs.editOrderGroupRef.showVisiable(
        {
          orderGroupObj:this.orderGroupObjList[0],
          groupList:groupList.length?groupList:this.orderGroupObjList,
          orderGroupCode:this.itemData.orderGroupCode,
          orderSendTimeObj:{
            startDate:this.itemData.startDate,
            endDate:this.itemData.endDate
          }
        }
      )
    },
    editGroupEvent() {

     },
    onModify(kn) {
      this.popData = {
        propKey: kn,
        orderId: this.itemData.guid,
        maxFlowNumPerDate: this.itemData.daliFlowLimit,
        maxPointLimitFlow: this.itemData.pointLimitFlow,
        maxPointLimitPlayCount: this.itemData.pointLimitPlayCount
      }
      this.cprPop = true
    },
    refreshOrder() {
      this.getOrder()
    },
    handleResize() {
      if (this.$refs.cplLabel) {
        const cw = this.$refs.cplLabel.clientWidth - 26 - 81 // 减去右内边距+边框+左外边距、"CPR+标签："占用宽度
        this.labelTip = cw < this.fullLabelName.widthForFontsize(14) ? this.fullLabelName : ''
      }
    },
    async changeContractNo() {
      let dest = this.destContractNo.trim()
      if (!dest) return this.messageTip('请输入正确的合同编码', 2)
      let param = {
        contractCode: dest,
        orderId: this.itemData.guid,
        orderCode: this.itemData.orderCode,
      }
      const groupList = await this.getOrderGroupLisrt({
        contractCodes:[dest]
      })
      // this.orderGroupObjList
      let orderGroupObj = this.orderGroupObjList[0]
      if (this.itemData.orderGroupCode && groupList.length) {
        const filterObj = groupList.filter(s => +new Date(s.startDate) === +new  Date(orderGroupObj.startDate) && +new Date(s.endDate) === +new  Date(orderGroupObj.endDate))
        if (filterObj.length) {
          param.orderGroupCode = filterObj[0].code
        } else {
          // 没有组别走编辑
          const topGroup = groupList[0]
          let _startDate = +new Date(topGroup.startDate) >= +new Date(orderGroupObj.startDate) ? orderGroupObj.startDate : topGroup.startDate
          let _endDate = +new Date(topGroup.endDate) >= +new Date(orderGroupObj.endDate)?topGroup.endDate:orderGroupObj.endDate
          const result = await this.fetch('/orderlite/contract/api/v4/contract/order-groups', {
            orderGroups: [{
              startDate: _startDate,
              endDate:_endDate,
              contractCode: dest,
              // tag: topGroup.tag,
              tag: '',

            }]
          }, 'post')
          if (result.code === 0) {
             param.orderGroupCode = result.data[0].code
          }
        }
      } else {
        console.log(orderGroupObj,'orderGroupObj')
        const result = await this.fetch('/orderlite/contract/api/v4/contract/order-groups', {
            orderGroups: [{
              startDate: orderGroupObj.startDate,
              endDate:orderGroupObj.endDate,
              contractCode: dest,
              tag:'',
            }]
          }, 'post')
          if (result.code === 0) {
             param.orderGroupCode = result.data[0].code
          }
      }
      let res = await this.fetch(`/orderlite/order/api/v4/order`, {
        ...param
        // orderGroupCode: ''
      }, 'put')
      if (res && res.code === 0) {
        this.messageTip(res.msg || '操作成功', 1)
        this.contarctChanging = false
        // this.itemData.contractNo = dest
        this.refreshOrder()
      } else this.messageTip(res.msg || '操作失败')
    },
    // 修改每日流量上限
    async changeDayTraffic(flag,num) {
      if (flag) {
        // 编辑
        this.dayTrafficChange = flag
        this.daliFlowLimitNum = this.itemData.daliFlowLimit ? this.itemData.daliFlowLimit / 1000 : 0
      } else {
        // 保存
        const params = {
            orderId: this.itemData.guid,
            orderCode: this.itemData.orderCode,
        }
        if (this.itemData.orderType === 6005) {
          params.pointLimitFlow = num * 1000
        } else if (this.itemData.orderType === 6010) {
          params.dailyLimitFlow = num * 1000
        }
        console.log(this.daliFlowLimitNum)
        let res = await this.fetch(`/orderlite/order/api/v4/order`, { ...params }, 'put')
        if (res && res.code === 0) {
          this.dayTrafficChange = flag
          this.itemData.daliFlowLimit = num * 1000
          this.messageTip(res.msg || '操作成功', 1)
        }

      }

    },
    changeVideoDone() {
      setTimeout(() => {
        this.getOrder()
      }, 200)
    },
    goBack() {
      if (history.length == 1) window.close()
      else window.history.go(-1)
    },
    toggleTypeTab(i) {
      if (this.allCommunityList[i] && this.allCommunityList[i].length > 0) this.curTab = i
    },
    bdClick() {
      document.body.click()
    },
    search(str) {
      let tabList = this.allCommunityList[this.curTab]
      if (str.trim() == '') this.showCommunityList = tabList
      else this.showCommunityList = tabList.filter(el => el.name.indexOf(str.trim()) > -1)
    },
    dateDeviceClick() {
      document.body.addEventListener('click', this.handlePopover, true)
    },
    handlePopover(e) {
      document.body.click()
      document.body.removeEventListener('click', this.handlePopover, true)
    },
    handleListCtnWidth() {
      if (this.$refs.listCtn) {
        let ww = this.$refs.listCtn.clientWidth - 40
        this.listCtnWidth = ww - ww % 210
        this.fixedWidth = document.getElementsByClassName('p-main')[0].clientWidth
      }
    },
    async getNbhdInfo(item) {
      let load = this.$loading()
      let res = await this.fetch('/dsp/web/order/v2/getOrderNbhdInfo', {
        nbhdGuid: item.guid, orderGuid: this.itemData.guid, screenType: this.curTab
      }, 'get')
      load.close()
      return res
    },
    async showWifiNbhdDtl(item) {
      if (!item.nbhdDailyRes || !item.nbhdDailyRes.length) {
        let res = await this.getNbhdInfo(item)
        if (res && res.code == this.successCode && res.data && res.data.length) {
          let first = res.data[0]
          this.$set(
            item, 'nbhdDailyRes',
            (() => {
              let result = []
              first.nhbdDeviceInfo.forEach(cur => {
                let build = cur.build
                cur.value.forEach(el => {
                  let ut = el.unit
                  el.elevatorNos.forEach(ele => result.push(`${build}${ut}${ele}`))
                })
              })
              return result
            })()
          )
        }
      }
    },
    async showNbhdDetail(item) {
      item.isOpen = !item.isOpen
      if (this.isShowBuild) await this.showWifiNbhdDtl(item) // 列表中需要直接展示楼幢单元梯号的情况
      else {
        if (!item.nbhdDailyRes || item.nbhdDailyRes.length == 0) {
          let loading = this.$loading()
          let res = await this.fetch('/dsp/web/order/v2/getOrderNbhdInfo', {
            nbhdGuid: item.guid, orderGuid: this.itemData.guid, screenType: this.curTab
          }, 'get')
          loading.close()
          if (res && res.code == this.successCode) {
            this.$set(item, 'nbhdDailyRes', res.data || [])
          }
        }
      }
    },
    handleShowFlowPredict() {
      let { predictFlow } = this.itemData
      let showFlowpredict = 0
      if (predictFlow) {
        predictFlow = predictFlow / 1000 + ''
        let dotIdx = predictFlow.indexOf('.')
        showFlowpredict = predictFlow.slice(0, dotIdx > -1 ? dotIdx + 3 : predictFlow.length)
      }
      this.itemData.showFlowpredict = showFlowpredict
    },
    changeJoinDate(str) {
      let s = (str || '').replace('-', '年').replace('-', '月')
      return s ? s + '日' : s
    },
    // 获取订单组别
    async getOrderGroupLisrt(params = {}) {
      let loading = this.$loading()
      const result = await this.fetch('/orderlite/contract/api/v4/contract/order-groups/page', {
          contractCodes: [this.itemData.contractNo],
          pageNum: 1,
          pageSize: 99999,
          ...params
      }, 'post')
      loading.close()
      if (result.code === this.successCode) {
        return result.data.list.map(s => {
          return {
            ...s,
            uuid:s.code
          }
        })
      }
    },
    async getOrder() {
      let loading = this.$loading()
      let response = await this.fetch('/dsp/web/order/v2/getOrderInfo', { guid: this.$route.query.id }, 'get')
      loading.close()
      if (response && response.code === this.successCode) {
        const resData = response.data || {}
        this.itemData = resData
        if (resData.orderGroupCode) {
          this.orderGroupObjList = await this.getOrderGroupLisrt({
            codes:[resData.orderGroupCode],
          })
        }else{
          this.orderGroupObjList = [{
            startDate: this.itemData.startDate,
            endDate: this.itemData.endDate,
            contractCode:this.itemData.contractNo,
            tag: '',
            uuid:jsUuid()
          }]
        }
        const { orderTargetLabels, validStartDate, validEndDate, unitPrice, stopTypes } = resData
        this.itemData.validStartDate = this.changeJoinDate(validStartDate)
        this.itemData.validEndDate = this.changeJoinDate(validEndDate)
        this.itemData.unitPrice = unitPrice === null ? '--' : (unitPrice / 1000).toFixed(2) + '元/千人次'
        let showAdd2 = stopTypes && stopTypes.length && stopTypes.indexOf(2) > -1
        this.itemData.showAdd2 = showAdd2

        this.handleShowFlowPredict() // 预计流量展示处理

        let timeSlotNames = this.itemData.timeSlotNames
        this.packageInfo = resData.packageInfo
        if (timeSlotNames) {
          this.itemData.timeSlotNames = timeSlotNames
            .replace(/（/g, '<span style="color: #999;margin-left: 5px;margin-right: 10px;">(')
            .replace(/）/g, ')</span> ')
        }
        this.leftSeconds = resData.valiPeriodSec || 0
        if (this.itemData.orderStatus == '0') {
          let inter = setInterval(() => {
            if (this.leftSeconds > 0) this.leftSeconds--
            else {
              clearInterval(inter)
              this.$set(this.itemData, 'orderStatusName', '已取消')
              this.$set(this.itemData, 'orderStatus', '1')
            }
          }, 1000)
        }

        let orderNbhdResList = resData.orderNbhdResList || [] // 梯内小区
        let twOrderNbhdResList = resData.twOrderNbhdResList || [] // 梯外小区

        this.communityList = orderNbhdResList.concat(twOrderNbhdResList).map(el => {
          this.$set(el, 'isOpen', false)
          this.$set(el, 'wifiList', [])
          return el
        })

        this.tnDeviceNum = orderNbhdResList.reduce((data, cur) => cur.deviceCount - 0 + data, 0)
        this.twDeviceNum = twOrderNbhdResList.reduce((data, cur) => cur.deviceCount - 0 + data, 0)

        this.allCommunityList = [orderNbhdResList, twOrderNbhdResList]
        this.showCommunityList = this.allCommunityList[this.curTab] || []

        const { personCodes, personNames, incomeLevelNames, communityNames, costTypeName, targetName, industryName, nbhdNames } = resData.searchLabelInfo || {}

        if (orderTargetLabels && orderTargetLabels.length) {
          this.$nextTick(() => {
            addResizeListener(this.$refs.cplLabel, this.handleResize)
          })
          this.targetLabels = (personCodes || []).map(portrait => {
            return portrait.map(code => {
              const current = orderTargetLabels.filter(w => w.code === code)
              if (current && current[0]) {
                return current[0]
              } else {
                console.warn('画像映射失败:', portrait, orderTargetLabels)
                return null
              }
            })
          }).filter(f => f)

        }

        this.labelData = {
          ...(resData.searchLabelInfo || {}),
          personCodes,
          personNames: this.concatStr(personNames || []),
          incomeLevelNames: (incomeLevelNames || []).join(','),
          communityNames: (communityNames || []).join(','),
          costTypeName, targetName, industryName,
          nbhdNames: nbhdNames || []
        }
        // 可能需要异步请求的放后面
        let labelStore = this.$store.state.label
        if (!labelStore.list.length) await this.$store.dispatch('label/getSearchLabels') // 标签Label
        let psNames = ['画像A', '画像B', '画像C', '画像D', '画像E']
        let personObjs = (personCodes || []).map((el, i) => {
          let data = (personCodes || [])[i]
          return {
            name: psNames[i],
            list: data ? data.map(ele => labelStore.codeMap[ele]) : []
          }
        })
        this.$set(this.labelData, 'personNamesData', personObjs)
      }
    },
    concatStr(arr) {
      if (!arr || arr.length == 0) return ''
      if (arr.length == 1) return arr[0].join('+') // 一个时 多个属性时不显示括号
      return arr.map(list => {
        let str = list.join('+')
        return list.length == 1 ? str : `(${str})` // 一个属性时不展示括号
      }).join(' 或 ')
    },
    async setCurrentDetail(row, type) {
      this.currentRow = {
        ...row
      }
      if (type == 'showUpload') {
        this.currentRow.advContentDto = await this.getOldResource(this.currentRow)
      }
      this.$set(this.currentRow, type, true)
    },
    async getOldResource(item) {
      let res = await this.fetch('/dsp/content/v2/queryContentByOrder?orderGuid=' + item.guid, '', 'get')
      if (res && res.code == this.successCode) return res.data[0] || {}
      else return {}
    },
    cancelOrder(row) {
      this.delItem = row
      this.$refs.cancelFixCenter.show()
    },
    cancelCancel() {
      this.delItem = null
      this.curReasonIdx = -1
      this.reasonStr = ''
      this.$refs.cancelFixCenter.hide()
    },
    async cancel() {
      if (this.curReasonIdx == -1) return this.messageTip('请选择取消理由')
      let reason = this.reasons[this.curReasonIdx]
      if (this.curReasonIdx == this.reasons.length - 1) reason += ': ' + this.reasonStr

      let res = await this.fetch('/dsp/web/order/v2/canlOrder', {
        cancelDesc: reason,
        orderGuid: this.delItem.guid
      })

      if (res && res.code == this.successCode) {
        this.messageTip(res.msg || '取消成功', 1)
        this.cancelCancel()
        this.getOrder()
      }
    },
    giveMark(row) {
      this.delItem = row
      this.$refs.markPop.show()
    },
    hideMarkPop() {
      this.delItem = null
      this.starIdx = -1
      this.judgeStr = ''
      this.$refs.markPop.hide()
    },
    async judge() {
      if (this.starIdx == -1) return this.messageTip('请选择评价等级')
      let res = await this.fetch('/dsp/orderaccess/v2/orderRate', {
        orderGuid: this.delItem.guid,
        appraisal: this.judgeStr.trim(),
        rate: this.starIdx + 1
      })
      if (res && res.code == this.successCode) {
        this.messageTip(res.msg || '评价成功', 1)
        this.hideMarkPop()
        this.getOrder()
      }
    }
  }
}
</script>
